export interface PackageTemplate {
    id?: number;
    appKey: string;
    env: string;
    name?: string;
    param: PackageParam;
    description?: string;
    createTime?: Date;
    updateTime?: Date;
}

export class PackageParam {
    gitBranchName: string;
    workDir: string;
    skipTests: boolean;
    variables: EnvironmentVariable[];

    buildType: BuildType;
    packageFile?: File;

    static ofDefault(): PackageParam {
        return {
            gitBranchName: "master",
            workDir: "",
            skipTests: false,
            buildType: "LOCAL",
            variables: []
        };
    }
}

export type BuildType = 'LOCAL' | 'REMOTE';

export class EnvironmentVariable {
    key: string;
    value: string;
}